// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","3502":"554f9e6b"}[chunkId] + ".chunk.css";
};